module.exports = __webpack_public_path__ + "static/media/arrow-prev.99eebf2a.svg";